export default {
  SET({commit}, payload) {
    commit('SET', payload)
  },

  // FROM HEADER
  SET_HEADER({commit}, payload) {
    commit('SET_HEADER', payload)
  },

  // CONTACT
  SET_CONTACT({commit}, payload) {
    commit('SET_CONTACT', payload)
  },
  SET_CONTACT_LINE({commit}, payload) {
    commit('SET_CONTACT_LINE', payload)
  },
  DELETE_CONTACT_LINE({commit}, payload) {
    commit('DELETE_CONTACT_LINE', payload)
  },

  // CARD
  SET_CARD_LINE({commit}, payload) {
    commit('SET_CARD_LINE', payload)
  },
  SET_CARD({commit}, payload) {
    commit('SET_CARD', payload)
  },
  DELETE_CARD_LINE({commit}, payload) {
    commit('DELETE_CARD_LINE', payload)
  },

  // SAMPLE
  SET_SAMPLE({commit}, payload) {
    commit('SET_SAMPLE', payload)
  },
  SET_SAMPLE_LINE({commit}, payload) {
    commit('SET_SAMPLE_LINE', payload)
  },
  DELETE_SAMPLE_LINE({commit}, payload) {
    commit('DELETE_SAMPLE_LINE', payload)
  },

  // GLOBAL
  SET_TTOP_GRAT({commit}, payload) {
    commit('SET_TTOP_GRAT', payload)
  },
  SET_TTOP_ELECTRO({commit}, payload) {
    commit('SET_TTOP_ELECTRO', payload)
  },
  SET_TYPOLOGY({commit}, payload) {
    commit('SET_TYPOLOGY', payload)
  },
  RESET({commit}, payload) {
    commit('RESET', payload)
  },

  // SPCIAL REQUEST
  SET_SPECIAL_REQUEST({commit}, payload) {
    commit('SET_SPECIAL_REQUEST', payload)
  },
}